import { defineMessages } from "react-intl";

const SKIP_TO_SECTION = "skip-to-section";

const skipToSectionMessages = defineMessages({
  myAccount: {
    id: `${SKIP_TO_SECTION}.my-account`,
    defaultMessage: "Skip to my account"
  },
  affiliations: {
    id: `${SKIP_TO_SECTION}.affiliations`,
    defaultMessage: "Skip to affiliations"
  },
  mergeAccounts: {
    id: `${SKIP_TO_SECTION}.merge-accounts`,
    defaultMessage: "Skip to merge accounts"
  }
});

export default skipToSectionMessages;
